<div *ngIf="print.load" class="body-wrapper" style="direction: rtl; padding-top: 0">
  <header class="header">
    <div style="margin-bottom: 3%;">
      <h3 class="header-title">
        טבלת תורים יומית:
      </h3>
    </div>
    <div class="header-details">
      <div style="display: inline-block; padding-left: 1em;">
        תאריך התורים:&nbsp;
        <strong style="direction: ltr;">
          {{ startDate | date: 'dd.MM.yyyy' }}
        </strong>
      </div>
      <div style="display: inline-block;">
        תאריך הדפסה:&nbsp;
        <strong style="direction: ltr;">
          {{ now | date: 'dd.MM.yyyy HH:mm' }}
        </strong>
      </div>
    </div>
  </header>

  <!-- ================ Multi Room View (Start) ================-->
  <ng-container *ngIf="type === 'multiRoom' && print.roomInfo?.length">
    <ng-container *ngFor="let room of print.roomInfo">
      <div class="room-header" style="text-align: center; margin-top: 2em;">
        <h2 style="margin: 1em 0;">חדר: {{ room.RoomName }}</h2>
      </div>

      <section class="section marginBottom" *ngIf="print.appointments?.length">
        <table class="l-table-auto weightAss-table">
          <tr class="l-row weightAss-thead">
            <th class="narrow">#</th>
            <th>שעות</th>
            <th>שם מטופל/ת</th>
            <th>ת.ז</th>
            <th>נייד</th>
            <th>גורם מפנה</th>
            <th class="l-td-m wide">הערה</th>
          </tr>
          <ng-container *ngFor="let apt of print.appointments | sortByDateTime; index as i">
            <tr *ngIf="apt.RID == room.AutoIndex" class="l-row weightAss-tbody">
              <td>{{ i + 1 }}</td>
              <td>
                <div style="display: flex; flex-direction: column; text-align: center;">
                  <label>{{ apt.aptTime | date: 'HH:mm' }}</label> -
                  <label>{{ apt.aptEndTime | date: 'HH:mm' }}</label>
                </div>
              </td>
              <td>{{ apt.First }} {{ apt.Last }}</td>
              <td>{{ apt.ID }}</td>
              <td>{{ apt.Mobile }}</td>
              <td>{{ getFundingText(apt.Funding, apt) }}</td>
              <td>{{ getExamName(apt) + (apt.comment ? ' '+ apt.comment: '') }}</td>
            </tr>
          </ng-container>
        </table>
      </section>
    </ng-container>
  </ng-container>
  <!-- ================ Multi Room View (End) ================-->

  <!-- ================ Multi Doctor View (Start) ================-->
  <ng-container *ngIf="type === 'multiDoctor' && print.doctorInfo?.length">
    <ng-container *ngFor="let doc of print.doctorInfo">
      <div class="room-header" style="text-align: center; margin-top: 2em;">
        <h2 style="margin: 1em 0;">רופא: {{ doc.Title }} {{ doc.Name }}</h2>
      </div>

      <section class="section marginBottom" *ngIf="print.appointments?.length">
        <table class="l-table-auto weightAss-table">
          <tr class="l-row weightAss-thead">
            <th class="narrow">#</th>
            <th>שעות</th>
            <th>שם מטופל/ת</th>
            <th>ת.ז</th>
            <th>נייד</th>
            <th>גורם מפנה</th>
            <th class="l-td-m wide">הערה</th>
          </tr>
          <ng-container *ngFor="let apt of print.appointments | sortByDateTime; index as i">
            <tr *ngIf="apt.DocUID == doc.UID" class="l-row weightAss-tbody">
              <td>{{ i + 1 }}</td>
              <td>
                <div style="display: flex; flex-direction: column; text-align: center;">
                  <label>{{ apt.aptTime | date: 'HH:mm' }}</label> -
                  <label>{{ apt.aptEndTime | date: 'HH:mm' }}</label>
                </div>
              </td>
              <td>{{ apt.First }} {{ apt.Last }}</td>
              <td>{{ apt.ID }}</td>
              <td>{{ apt.Mobile }}</td>
              <td>{{ getFundingText(apt.Funding, apt) }}</td>
              <td>{{ getExamName(apt) + (apt.comment ? ' '+ apt.comment: '') }}</td>
            </tr>
          </ng-container>
        </table>
      </section>
    </ng-container>
  </ng-container>
  <!-- ================ Multi Doctor View (End) ================-->

  <!-- ================ Single Doctor/Room View (Start) ================-->
  <ng-container *ngIf="type !== 'multiRoom' && type !== 'multiDoctor'">
    <div *ngIf="docUID" class="justify-between items-center" style="text-align: center; margin-bottom: 3%;">
      <h1 class="header-title">שם הרופא: {{ print.doctorInfo[0].Title }} {{ print.doctorInfo[0].Name }}</h1>
    </div>
    <div *ngIf="roomID" class="justify-between items-center" style="text-align: center; margin-bottom: 3%;">
      <h1 class="header-title">שם החדר: {{ print.roomInfo[0].RoomName }}</h1>
    </div>

    <section class="section marginBottom" *ngIf="print.appointments && print.appointments.length">
      <table class="l-table-auto weightAss-table">
        <tr class="l-row weightAss-thead">
          <th class="narrow">#</th>
          <th>שעות</th>
          <th>שם מטופל/ת</th>
          <th>ת.ז</th>
          <th>נייד</th>
          <th>גורם מפנה</th>
          <th class="l-td-m wide">הערה</th>
        </tr>

        <ng-container *ngFor="let appointment of print.appointments | sortByDateTime; index as i">
          <tr class="l-row weightAss-tbody">
            <td>{{ i + 1 }}</td>
            <td>
              <div style="display: flex; flex-direction: column; text-align: center;">
                <label>{{ appointment.aptTime | date: 'HH:mm' }}</label> -
                <label>{{ appointment.aptEndTime | date: 'HH:mm' }}</label>
              </div>
            </td>
            <td>{{ appointment.First }} {{ appointment.Last }}</td>
            <td>{{ appointment.ID }}</td>
            <td>{{ appointment.Mobile }}</td>
            <td>{{ getFundingText(appointment.Funding, appointment) }}</td>
            <td style="text-align: center;">{{ getExamName(appointment) + (appointment.comment ? ' '+ appointment.comment: '') }}</td>
          </tr>
        </ng-container>
      </table>
    </section>
  </ng-container>
  <!-- ================ Single Doctor/Room View (End) ================-->

</div>